import { useEffect, useRef, useState, useCallback } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { useT } from "../../lib/i18n";
import { timeAgo } from "../../lib/channels";
import { toast } from "sonner";

export default function TechChat() {
  const t = useT();
  const [msgs, setMsgs] = useState([]); const [text, setText] = useState(""); const end = useRef(null);
  const load = useCallback(() => api.get("/chat/my").then((r) => setMsgs(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [msgs]);
  const send = async () => { if (!text.trim()) return; try { await api.post("/chat/my", { text }); setText(""); load(); } catch { toast.error("Gönderilemedi (internet?)"); } };
  return (
    <div className="flex flex-col h-[calc(100vh-11rem)]" data-testid="tech-chat">
      <div className="text-sm font-semibold mb-2">{t("Merkez ile sohbet")}</div>
      <div className="flex-1 overflow-y-auto space-y-2 pr-1">
        {msgs.length === 0 && <div className="text-sm text-slate-500 text-center mt-8">{t("Arıza kodu, parça veya fiyat konusunda merkeze yazabilirsiniz.")}</div>}
        {msgs.map((m) => <div key={m.id} className={`max-w-[85%] p-2 rounded-lg text-sm ${m.sender_role === "technician" ? "ml-auto bg-blue-600 text-white" : "bg-white border"}`}>{m.text}<div className={`text-[10px] mt-1 ${m.sender_role === "technician" ? "text-blue-100" : "text-slate-400"}`}>{timeAgo(m.created_at)}</div></div>)}
        <div ref={end} />
      </div>
      <div className="flex gap-2 pt-2"><Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder={t("Mesaj yazın…")} data-testid="tchat-input" /><Button onClick={send} className="bg-blue-600 hover:bg-blue-700" data-testid="tchat-send">{t("Gönder")}</Button></div>
    </div>
  );
}
